import {
  Box,
  ButtonBase,
  Skeleton,
  Typography,
} from "@mui/material";
import React from "react";
import { ExpandImageIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ExpandImageIcon";
import { GenerationIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerationIcon";
import BeforeAfterSlider from "./Before&AfterSlider";
import ChatResponseFormat from "../../../main-page/components/get-conversation/ChatResponseFormat";
import { DownloadImage } from "../../../../shared/DownloadImage";
import "../../View/ImageSuites.css";

const iconContainerStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background:
    "linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%)",
  opacity: 0,
  transition: "opacity 0.3s ease",
  "&:hover": {
    opacity: 1,
  },
};

const iconStyle = {
  width: "32px",
  height: "32px",
  backgroundColor: "rgba(255, 255, 255, 0.51)",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "#FFF",
  },
};

interface OutputImageProps {
  imgUrl: string;
  exampleImgUrl?: string;
  isLoading?: boolean;
  slider: boolean;
  sliderData?: {
    beforeImage: string;
    afterImage: string;
  };
  outputImage?: boolean;
  handleOpenExpandImage?: (() => void) | undefined;
}

export const OutputImage = ({
  imgUrl,
  exampleImgUrl,
  isLoading = false,
  slider,
  sliderData,
  outputImage,
  handleOpenExpandImage,
}: OutputImageProps) => {
  const renderImageLoading = () => (
    <Box className="generate-loading-container">
      <Box className="image-suite-generation-loading">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <GenerationIcon />
          <Typography className="generation-loading-text">Generate</Typography>
        </Box>
      </Box>
    </Box>
  );

  const renderTextLoading = () => (
    <Box sx={{ width: "100%", height: "100%" }}>
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton
          key={index}
          animation="wave"
          variant="text"
          width={
            index === 0
              ? "100%"
              : index === 1
              ? "80%"
              : index === 2
              ? "40%"
              : "100%"
          }
          height={25}
          className="suites-skeleton"
        />
      ))}
    </Box>
  );

  const renderTextExtracted = () => (
    <Box className="extracted-text-container">
      <ChatResponseFormat response={imgUrl} />
    </Box>
  );

  const renderGeneratedImage = (imageURL:string) => (
    <Box className="generated-image-container">
      <Box className="generated-image-box" sx={{ position: "relative" }}>
        <img src={imageURL} alt="Generated output" style={{ width: "100%" ,objectFit:"contain"}} />
        <Box sx={iconContainerStyle}>
          <Box  sx={{
              p: 1,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
            }}>
             <DownloadImage style={iconStyle } imgURL={imageURL} />
            <ButtonBase sx={{ ...iconStyle,borderRadius:"1.391px 8.348px 1.391px 1.391px"}} onClick={handleOpenExpandImage}>
              <ExpandImageIcon />
            </ButtonBase>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  const renderSlider = () => (
    <BeforeAfterSlider
      beforeImage={sliderData?.beforeImage ?? ""}
      afterImage={sliderData?.afterImage ?? ""}
    />
  );

  return (
    <Box
      className="generated-img-ex-container">
      {isLoading ? (
        <>{outputImage ? renderImageLoading() : renderTextLoading()}</>
      ) : imgUrl ? (
        <>{outputImage ? renderGeneratedImage(imgUrl) : renderTextExtracted()}</>
      ) : slider ? (
        renderSlider()
      ) : exampleImgUrl ? (
        renderGeneratedImage(exampleImgUrl)
      ) : null}
    </Box>
  );
};
